import clsx from "clsx";
import type { ComponentProps } from "react";

import { ContactMapCard } from "@widgets/contact-map-card";

import { ArticleContent } from "@features/article-content/ui";

import type { EventType } from "../model";
import { ComingEvents } from "./coming-events";
import { Hero } from "./hero";

import s from "./EventPage.module.scss";

export type EventPageProps = ComponentProps<"div"> & {
  event: EventType;
  comingEvents: EventType[];
};

export const EventPage = (props: EventPageProps) => {
  const { event, comingEvents } = props;

  return (
    <div className={clsx(s.root)}>
      {event && <Hero data={event} />}
      {event.content && <ArticleContent articleBlocks={event.content} />}
      {event.contactMapSection && (
        <div className={clsx(s.mapContainer)}>
          <ContactMapCard {...event.contactMapSection} />
        </div>
      )}
      {comingEvents.length > 0 && <ComingEvents events={comingEvents} />}
    </div>
  );
};

EventPage.displayName = "EventPage";
